import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Trash2 } from "lucide-react";

import { API } from "@/lib/api";
const apiUrl = (p) => `${API}${p}`;

// Static motion configs — declared once at module scope so React skips work
// when comparing stable object references across renders.
const FIG_INITIAL = { opacity: 0, scale: 0.96 };
const FIG_ANIMATE = { opacity: 1, scale: 1 };
const FIG_EXIT = { opacity: 0, scale: 0.92 };
const FIG_TRANSITION = { duration: 0.35 };

export default function AdminPhotoGrid({ photos, onDelete }) {
  return (
    <div className="lg:col-span-7">
      <div className="flex items-center justify-between mb-5">
        <div>
          <span className="mn-eyebrow">Galeria publicada</span>
          <h2 className="font-serif-display font-extrabold text-2xl text-[var(--mn-black)] mt-3">
            {photos.length} foto(s) no site
          </h2>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-testid="admin-photo-grid">
        <AnimatePresence>
          {photos.map((p) => (
            <motion.figure
              key={p.id}
              layout
              initial={FIG_INITIAL}
              animate={FIG_ANIMATE}
              exit={FIG_EXIT}
              transition={FIG_TRANSITION}
              className="relative bg-white border border-[var(--mn-line)] rounded-[4px] overflow-hidden group"
              data-testid={`admin-photo-${p.id}`}
            >
              <div className="aspect-square bg-[#0e0e0e]">
                <img src={apiUrl(`/gallery/file/${p.id}`)} alt={p.title || ""} className="w-full h-full object-cover" />
              </div>
              <figcaption className="p-3 flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="text-xs font-semibold text-[var(--mn-black)] truncate">{p.title || "Sem título"}</div>
                  <div className="text-[0.65rem] uppercase tracking-[0.18em] text-[var(--mn-gold)] mt-1">{p.category}</div>
                </div>
                <div className="flex items-center gap-1 shrink-0">
                  <button
                    onClick={() => onDelete(p.id)}
                    className="p-1.5 text-[var(--mn-dark)] hover:text-red-600 transition-colors"
                    aria-label="Remover"
                    data-testid={`admin-delete-${p.id}`}
                  >
                    <Trash2 size={15} />
                  </button>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </AnimatePresence>
        {photos.length === 0 && (
          <div className="col-span-full text-sm text-[var(--mn-dark)] py-12 text-center border border-dashed border-[var(--mn-line)] rounded-[4px]">
            Nenhuma foto enviada ainda. Use o formulário ao lado para começar.
          </div>
        )}
      </div>
    </div>
  );
}
